import { Divider, Paper, Typography } from "@mui/material";
import { Box, display, styled } from "@mui/system";

export const CustomDivider = styled(Divider)({
  margin: "8px 0",
  borderColor: "rgba(0, 0, 0, 0.6)",
});

export const Root = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  fontFamily: theme.typography.fontFamily,
  paddingTop: "4rem",
  paddingBottom:"1rem"
}));
export const ImageBox = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  padding: theme.spacing(10),
  borderRadius: "8px",
  // width: "480px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));
export const FormBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  right: "-180px",
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  width: "360px",
  // height: "430px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  padding: theme.spacing(8),
  borderRadius: "8px",
  [theme.breakpoints.down("sm")]: {
    position: "relative",
    width: "100%",
    height: "auto",
    right: "0",
    top: "0",
    transform: "none",
    padding: theme.spacing(4),
  },
}));
export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // alignItems: "center",
  // textAlign: "center",
}));
export const ListTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "Urbane-Light",
  color: "#444444",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "22px",
  textAlign: "left",
  marginBottom: ".5rem",
}));

export const FormPaper = styled(Paper)(({ theme }) => ({
  // display: "flex",
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  maxWidth: "720px",
  width: "100%",
  margin: "auto",
}));
export const RightSection = styled(Box)(({ theme }) => ({
  // flex: 1,
  padding: theme.spacing(2),
}));
export const Image = styled("img")({
  width: "100%",
  maxWidth: "300px",
  borderRadius: "8px",
});

export const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "4px",
    padding: "0 8px",
    fontFamily: "Urbane-Light",
    borderColor: state.selectProps.error ? "#d32f2f" : provided.borderColor,
    minHeight: "40px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "&:hover": {
      borderColor: state.selectProps.error ? "#d32f2f" : provided.borderColor,
    },
    boxShadow: state.isFocused && "0 0 0 2px rgba(211, 47, 47, 0.25)",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "rgba(0, 0, 0, 0.4)",
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Urbane-Light",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "13px",
    fontFamily: "Urbane-Light",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "100%", // Ensure the indicator (arrow) aligns with the control
    display: "flex",
    alignItems: "center", // Vertically center the arrow
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Urbane-Light !important", // Apply Urbane-Light font to option
    fontSize: "14px",
    backgroundColor: state.isSelected ? "#e0e0e0" : provided.backgroundColor, // Optional: Change background on selection
  }),
};

// export const selectCustomStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     marginBottom: "8px",
//     // marginTop: "16px",
//     borderRadius: "4px",
//     padding: "8px",
//     // borderColor: "#ced4da",
//     borderColor:
//       state.isFocused || state.selectProps.error
//         ? "#d32f2f"
//         : provided.borderColor,
//     height: "25px",
//     "&:hover": {
//       // borderColor: "#80bdff",
//       borderColor: state.selectProps.error ? "#d32f2f" : provided.borderColor,
//     },
//     boxShadow: state.isFocused && "0 0 0 2px rgba(211, 47, 47, 0.25)",
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: "#6c757d",
//     fontSize: "16px",
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     fontSize: "16px",
//   }),
//   menu: (provided) => ({
//     ...provided,
//     zIndex: 100,
//   }),
// };
